import { Currency } from '../Currency'
import { NativeCurrency } from '../NativeCurrency'
import { Token } from '../Token'
import { WETH9 } from '../../constants/tokens'
import invariant from 'tiny-invariant'

/**
 * Shiden is the main usage of a 'native' currency, i.e. for Shiden mainnet and all testnets
 */
export class Shiden extends NativeCurrency {
  protected constructor(chainId: number) {
    super(chainId, 18, 'SDN', 'Shiden')
  }

  public get wrapped(): Token {
    const weth9 = WETH9[this.chainId]
    invariant(!!weth9, 'WRAPPED')
    return weth9
  }

  private static _cache: { [chainId: number]: Shiden } = {}

  public static onChain(chainId: number): Shiden {
    return this._cache[chainId] ?? (this._cache[chainId] = new Shiden(chainId))
  }

  public equals(other: Currency): boolean {
    return other.isNative && other.chainId === this.chainId
  }
}
